module.exports = __webpack_public_path__ + "static/media/how_el.92966a60.vtt";